// frontend/src/components/PortadorModal/PortadorModal.jsx

import React, { useEffect } from 'react';
import { Modal, Form, Input, Checkbox, message } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { updatePortador, createPortador } from '../../services/milhasService';
import { getErrorMessage } from '../../utils/errorHandler';
import { getMobileFullscreenModalProps } from '../../utils/mobileModal';

const PortadorModal = ({ visible, onClose, onSuccess, portador }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [form] = Form.useForm();
    // Hook de mensagem para consistência
    const [messageApi, contextHolder] = message.useMessage();
    const isEditing = !!portador;

    useEffect(() => {
        if (visible) {
            if (isEditing) {
                form.setFieldsValue(portador);
            } else {
                form.resetFields();
            }
        }
    }, [visible, portador, isEditing, form]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            
            // CORREÇÃO: Remove caracteres não numéricos do CPF antes de enviar
            if (values.cpf) {
                values.cpf = values.cpf.replace(/\D/g, '');
            }

            if (isEditing) {
                await updatePortador(portador.id, values);
                messageApi.success('Portador atualizado com sucesso!');
            } else {
                await createPortador(values);
                messageApi.success('Portador criado com sucesso!');
            }
            onSuccess();
        } catch (error) {
            // 2. USO NO SAVE
            messageApi.error(getErrorMessage(error, 'Erro ao salvar o portador.'));
        }
    };

    return (
        <Modal
            title={isEditing ? 'Editar Portador' : 'Novo Portador'}
            open={visible}
            onCancel={onClose}
            onOk={handleSave}
            okText="Salvar"
            cancelText="Cancelar"
            destroyOnClose
            okButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            cancelButtonProps={{ block: isMobile, size: isMobile ? 'large' : 'middle' }}
            {...getMobileFullscreenModalProps(isMobile)}
        >
            {contextHolder}
            <Form form={form} layout="vertical" size={isMobile ? 'large' : 'middle'}>
                <Form.Item name="nome_completo" label="Nome Completo" rules={[{ required: true, message: 'Este campo é obrigatório' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="cpf" label="CPF" rules={[{ required: true, message: 'Este campo é obrigatório' }]}>
                    {/* Placeholder para orientar o usuário */}
                    <Input placeholder="Somente números ou com pontuação" />
                </Form.Item>
                <Form.Item name="is_principal" valuePropName="checked">
                    <Checkbox>É o portador principal?</Checkbox>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PortadorModal;